import { render, staticRenderFns } from "./TableViewGoal.vue?vue&type=template&id=5249cf5a&"
import script from "./TableViewGoal.vue?vue&type=script&lang=js&"
export * from "./TableViewGoal.vue?vue&type=script&lang=js&"
import style0 from "./TableViewGoal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports